import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="calendar_date" size=32 />
 */

var CalendarDate = function CalendarDate() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M4.78003 11.07V7.32996C4.78003 7.06474 4.88539 6.81039 5.07292 6.62285C5.26046 6.43531 5.51481 6.32996 5.78003 6.32996H26.49C26.7552 6.32996 27.0096 6.43531 27.1971 6.62285C27.3847 6.81039 27.49 7.06474 27.49 7.32996V28.39C27.49 28.6552 27.3847 28.9095 27.1971 29.0971C27.0096 29.2846 26.7552 29.39 26.49 29.39H5.78003C5.51481 29.39 5.26046 29.2846 5.07292 29.0971C4.88539 28.9095 4.78003 28.6552 4.78003 28.39V11.07Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78003 6.82996C5.64742 6.82996 5.52024 6.88263 5.42648 6.9764C5.33271 7.07017 5.28003 7.19735 5.28003 7.32996V28.39C5.28003 28.5226 5.33271 28.6497 5.42648 28.7435C5.52024 28.8373 5.64742 28.89 5.78003 28.89H26.49C26.6226 28.89 26.7498 28.8373 26.8436 28.7435C26.9373 28.6497 26.99 28.5226 26.99 28.39V7.32996C26.99 7.19735 26.9373 7.07017 26.8436 6.9764C26.7498 6.88263 26.6226 6.82996 26.49 6.82996H5.78003ZM4.71937 6.2693C5.00067 5.98799 5.3822 5.82996 5.78003 5.82996H26.49C26.8879 5.82996 27.2694 5.98799 27.5507 6.2693C27.832 6.5506 27.99 6.93213 27.99 7.32996V28.39C27.99 28.7878 27.832 29.1693 27.5507 29.4506C27.2694 29.7319 26.8879 29.89 26.49 29.89H5.78003C5.38221 29.89 5.00067 29.7319 4.71937 29.4506C4.43806 29.1693 4.28003 28.7878 4.28003 28.39V7.32996C4.28003 6.93213 4.43806 6.5506 4.71937 6.2693Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M4.78003 11.0699H27.49V28.3899C27.49 28.6552 27.3847 28.9095 27.1971 29.0971C27.0096 29.2846 26.7552 29.3899 26.49 29.3899H5.78003C5.51481 29.3899 5.26046 29.2846 5.07292 29.0971C4.88539 28.9095 4.78003 28.6552 4.78003 28.3899V11.0699Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28003 11.0699C4.28003 10.7938 4.50389 10.5699 4.78003 10.5699H27.49C27.7662 10.5699 27.99 10.7938 27.99 11.0699V28.3899C27.99 28.7878 27.832 29.1693 27.5507 29.4506C27.2694 29.7319 26.8879 29.8899 26.49 29.8899H5.78003C5.38221 29.8899 5.00067 29.7319 4.71937 29.4506C4.43806 29.1693 4.28003 28.7878 4.28003 28.3899V11.0699ZM5.28003 11.5699V28.3899C5.28003 28.5226 5.33271 28.6497 5.42648 28.7435C5.52024 28.8373 5.64742 28.8899 5.78003 28.8899H26.49C26.6226 28.8899 26.7498 28.8373 26.8436 28.7435C26.9373 28.6497 26.99 28.5226 26.99 28.3899V11.5699H5.28003Z",
    fill: "#002D55"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8 3.12C11.4022 3.12 11.0207 3.27803 10.7394 3.55933C10.4581 3.84064 10.3 4.22217 10.3 4.62V8.68H9.30005V4.62C9.30005 3.95695 9.56344 3.32107 10.0323 2.85223C10.5011 2.38339 11.137 2.12 11.8 2.12C12.4631 2.12 13.099 2.38339 13.5678 2.85223C14.0367 3.32107 14.3 3.95695 14.3 4.62V6H13.3V4.62C13.3 4.22217 13.142 3.84064 12.8607 3.55933C12.5794 3.27803 12.1979 3.12 11.8 3.12Z",
    fill: "#002D55"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.27 3.12C20.8722 3.12 20.4907 3.27803 20.2094 3.55933C19.9281 3.84064 19.77 4.22217 19.77 4.62V8.68H18.77V4.62C18.77 3.95695 19.0334 3.32107 19.5023 2.85223C19.9711 2.38339 20.607 2.12 21.27 2.12C21.9331 2.12 22.5689 2.38339 23.0378 2.85223C23.5066 3.32107 23.77 3.95695 23.77 4.62V6H22.77V4.62C22.77 4.22217 22.612 3.84064 22.3307 3.55933C22.0494 3.27803 21.6678 3.12 21.27 3.12Z",
    fill: "#002D55"
  }), React.createElement("path", {
    d: "M10.03 13.95H7.65002V16.33H10.03V13.95Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M14.89 13.95H12.51V16.33H14.89V13.95Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M19.75 13.95H17.37V16.33H19.75V13.95Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M24.61 13.95H22.23V16.33H24.61V13.95Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M10.03 19.04H7.65002V21.42H10.03V19.04Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M14.89 19.04H12.51V21.42H14.89V19.04Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M19.75 19.04H17.37V21.42H19.75V19.04Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M24.61 19.04H22.23V21.42H24.61V19.04Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M10.03 24.14H7.65002V26.52H10.03V24.14Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M14.89 24.14H12.51V26.52H14.89V24.14Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M19.75 24.14H17.37V26.52H19.75V24.14Z",
    fill: "#B9DEFA"
  }), React.createElement("path", {
    d: "M24.61 24.14H22.23V26.52H24.61V24.14Z",
    fill: "#B9DEFA"
  }));
};

export default CalendarDate;